import { EncryptedBadge } from "../../../../redux/types";
import { FREYA_SCANNERS_LARGE, FREYA_SCANNERS_LARGE_SUCCESS } from "../../../../common/constants";
import { Nullable } from "../../../../common/types";

export const createBadgesIndexesMapBasingOnArray = (currentBadges: EncryptedBadge[]) => {
  const badgesIndexesMap: { [key: string]: number } = {};
  for (let i = 0; i < currentBadges.length; i++) {
    const currentBadge = currentBadges[i]!;
    badgesIndexesMap[currentBadge.badgeId] = i;
  }
  return badgesIndexesMap;
};

export const addOrUpdateBadgesArray = (newBadges: EncryptedBadge[], arrayToUpdate: EncryptedBadge[]) => {
  const badgesIndexesMap = createBadgesIndexesMapBasingOnArray(arrayToUpdate);

  for (const badge of newBadges) {
    let cachedBadgeIndex = badgesIndexesMap[badge.badgeId];
    if (cachedBadgeIndex) {
      arrayToUpdate[cachedBadgeIndex] = badge;
      continue;
    }
    arrayToUpdate.push(badge);
  }
  return arrayToUpdate;
};

export const getSelectedScannerImage = (selectedScannerId: Nullable<string>) => {
  if (!selectedScannerId) return null;
  const selectedScanner = FREYA_SCANNERS_LARGE.find(scanner => scanner.id === selectedScannerId);
  return selectedScanner?.image;
};

export const getSuccessScannedImage = (selectedScannerId: Nullable<string>) => {
  if (!selectedScannerId) return null;
  const selectedScanner = FREYA_SCANNERS_LARGE_SUCCESS.find(scanner => scanner.id === selectedScannerId);
  return selectedScanner?.image;
};
